import '@vaadin/password-field';
import { componentName, PasswordClass } from './PasswordClass';

customElements.define(componentName, PasswordClass);

export { PasswordClass, componentName };
